import { ON_ORDERS_CHANGE, RESET_ACCOUNT_DATA } from "../../actions/types";

const initialState = {
  items: [],
  isFetching: false,
  updatedAt: null
}

const onChange = (state, {updates}) => {
  const items = state.items.slice()

  updates.added.forEach(n => {
    if(items.findIndex(o => o.id === n.id)<0) {
      items.push(n)
    }
  })

  updates.modified.forEach(m => {
    const index = items.findIndex(o => o.id === m.id)
    items[index] = {...m}
  })
  updates.removed.forEach(r => {
    const index = items.findIndex(o => o.id === r.id)
    items.splice(index,1)
  })

  items.sort((a,b) => {
    if(a.date > b.date) return -1
    if(a.date < b.date) return 1
    return 0
  })

  return {...state, items, isFetching: false, updatedAt: Date.now()}
}

const reset = () => ({...initialState})

export default (state = initialState, action) => {
  switch (action.type) {
    case ON_ORDERS_CHANGE: return onChange(state,action)
    case RESET_ACCOUNT_DATA: return reset(state,action)
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/redux/reducers/orders.js